import { render, staticRenderFns } from "./roleAssignment.vue?vue&type=template&id=4f720fe4&scoped=true"
import script from "./roleAssignment.vue?vue&type=script&lang=js"
export * from "./roleAssignment.vue?vue&type=script&lang=js"
import style0 from "./roleAssignment.vue?vue&type=style&index=0&id=4f720fe4&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f720fe4",
  null
  
)

export default component.exports